import React, {useEffect} from "react";
import {createPortal} from "react-dom";

export const Modal = ({isOpen, onClose, children}) => {

    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (event) => {
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    // Block page scrolling while open
    useEffect(() => {
        if (!isOpen) return;
        const {documentElement: html, body} = document;
        const prevHtmlOverflow = html.style.overflow;
        const prevBodyOverflow = body.style.overflow;
        html.style.overflow = "hidden";
        body.style.overflow = "hidden";
        return () => {
            html.style.overflow = prevHtmlOverflow;
            body.style.overflow = prevBodyOverflow;
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return createPortal(
        <div className="Modal" onClick={onClose}>
            <div className="Modal-Content" onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>,
        document.body
    );
}
